import {PageBreakRules} from "./page-break-rules.abstract";

export class BaskRulesService extends PageBreakRules {
  title = "Welcome to Bask Bank";
  subTitle = "Here’s what you need:";
  requiredInfoContainerClass = "";
  ssImage = "/assets/images/bask/card-icon.svg";
  idTitle = "Valid Government Issued ID";
  idImage = "/assets/images/bask/id-icon.svg";
  mobileImage = "/assets/images/bask/mobile-dialog-icon.svg";
  mobileDescription = "To confirm your identity, we may ask you to take a selfie and upload a photo of your ID using your mobile device.";
  faqUrl = "https://www.baskbank.com/faq#opening-an-account";
}
